import { render, staticRenderFns } from "./workflow-visualization.vue?vue&type=template&id=0d8bc84e&scoped=true&"
import script from "./workflow-visualization.vue?vue&type=script&lang=js&"
export * from "./workflow-visualization.vue?vue&type=script&lang=js&"
import style0 from "./workflow-visualization.vue?vue&type=style&index=0&id=0d8bc84e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bc84e",
  null
  
)

export default component.exports